var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 18,
    fill: "none",
    viewBox: "0 0 28 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 .5h20A3.5 3.5 0 0 1 27.5 4v10a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 14V4A3.5 3.5 0 0 1 4 .5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E7EC",
    d: "M4 .5h20A3.5 3.5 0 0 1 27.5 4v10a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 14V4A3.5 3.5 0 0 1 4 .5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M11.5 13.2c2.416 0 4.375-1.88 4.375-4.2S13.916 4.8 11.5 4.8 7.125 6.68 7.125 9s1.959 4.2 4.375 4.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M16.5 13.2c2.416 0 4.375-1.88 4.375-4.2S18.916 4.8 16.5 4.8 12.125 6.68 12.125 9s1.959 4.2 4.375 4.2"
  })));
};
export default SvgMastercard;